export default __webpack_public_path__ + "static/media/pic76.db7962d4.jpg";